var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillingTierCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "10 11 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hugeicons:checkmark-badge-01"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.388 32.4H31.4M31.388 32.4C30.6416 33.1404 29.288 32.9568 28.3376 32.9568C27.1712 32.9568 26.6096 33.1848 25.778 34.0164C25.07 34.7244 24.1208 36 23 36C21.8792 36 20.93 34.7244 20.222 34.0164C19.3892 33.1848 18.8276 32.9568 17.6624 32.9568C16.7132 32.9568 15.3584 33.1416 14.6108 32.4C13.8584 31.6536 14.0432 30.2928 14.0432 29.3376C14.0432 28.1292 13.7792 27.5736 12.9188 26.7144C11.6396 25.4352 11 24.7944 11 24C11 23.2056 11.6396 22.5648 12.92 21.2856C13.688 20.5176 14.0432 19.7568 14.0432 18.6624C14.0432 17.7132 13.8584 16.3584 14.6 15.6108C15.3464 14.8584 16.7072 15.0432 17.6624 15.0432C18.7568 15.0432 19.5176 14.6868 20.2856 13.9188C21.5648 12.6396 22.2056 12 23 12C23.7944 12 24.4352 12.6396 25.7144 13.92C26.4824 14.688 27.2432 15.0432 28.3376 15.0432C29.2868 15.0432 30.6416 14.8584 31.3892 15.6C32.1416 16.3464 31.9568 17.7072 31.9568 18.6624C31.9568 19.8708 32.2208 20.4264 33.0812 21.2856C34.3604 22.5648 35 23.2056 35 24C35 24.7944 34.3604 25.4352 33.08 26.7144C32.2208 27.5748 31.9568 28.1304 31.9568 29.3376C31.9568 30.2928 32.1404 31.6536 31.388 32.4Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.3077 24.9891C19.3077 24.9891 20.7846 25.7113 21.5231 26.7692C21.5231 26.7692 23.7384 22.6153 26.6923 21.2307",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingTierCheckmark);
export default __webpack_public_path__ + "static/media/billing-tier-checkmark.e3398ec96dd6ff45139b768e47c1223a.svg";
export { ForwardRef as ReactComponent };